import React, { useEffect, useRef, useState } from 'react'
import Carousel from 'react-multi-carousel'
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Product from './Product';
import ProductQuickViewModal from '../PlpSection/ProductQuickViewModal';
import AddToCartSuccessModal from '../PlpSection/AddToCartSuccessModal';
import AddShoppingListModal from '../PlpSection/AddShoppingListModal';
import { DEFAULT_IMAGE_140 } from '../../middleware/types'
import { useSelector } from 'react-redux';
import useStateRef from 'react-usestateref';
import ProductTile from '../PlpSection/ProductTile';

const FeaturedProductSlider = (props) => {

	const [containerObject, setContainerObject] = useState(props.containerObject ? props.containerObject : "");
	const [title, setTitle] = useState(props.containerObject && props.containerObject.attributes && props.containerObject.attributes.title ? props.containerObject.attributes.title : "")
	const [currentSlide, setCurrentSlide] = useState(0);
	const [titleCss, setTitleCss] = useState(props.containerObject && props.containerObject.attributes && props.containerObject.attributes.titleCss ? props.containerObject.attributes.titleCss : "")
	const carouselRef = useRef(null);
	const [quickView, setQuickView] = useState(containerObject.attributes && containerObject.attributes.hideQuickView ? containerObject.attributes.hideQuickView : "false");
	const [productDetailsObj, setproductDetailsObj] = useState('')
	const [cartProductDetails, setCartProductDetails] = useState('')
	const [productCount, setProductCount] = useState('')
	const [screenWidth, setScreenWidth, screenWidthRef] = useStateRef()
	const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)
	const [isAddToCartAction, setIsAddToCartAction, isAddToCartActionRef] = useStateRef(true);

	const handleQuickViewProductPage = (event) => {
		event.preventDefault()
		setproductDetailsObj("")
		var formData = new FormData(event.target);
		const productId = formData.get("productIdss")
		const productCount = formData.get("productCount")
		fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/product/product-quick-view/${productId}`, {
			method: 'GET'
		}).then(res => res.json())
			.then(res => {
				if (res !== null) {
					var productDetatils = (JSON.parse(res.response)).response
					setproductDetailsObj(productDetatils)
					setProductCount(productCount ? productCount : "")
					var modalElement = document.getElementById(`${productId ? productId : "quickViewModal"}`);
					var bootstrapModal = new bootstrap.Modal(modalElement);
					bootstrapModal.show();
				} else {
					// don't do anythink
				}
			})
	}

	const cartProductDetailsCallBack = (productDetails) => {
		setCartProductDetails(productDetails)
	}

	const responsive = {
		superLargeDesktop: {
			breakpoint: { max: 4000, min: 3000 },
			items: containerObject && containerObject.attributes && containerObject.attributes.superLargeDesktop ? parseInt(containerObject.attributes.superLargeDesktop) : 4,
			partialVisibilityGutter: (containerObject && containerObject.results && containerObject.results.length) == (containerObject && containerObject.attributes && containerObject.attributes.superLargeDesktop ? parseInt(containerObject.attributes.superLargeDesktop) : 4) ? 0 :
				(containerObject && containerObject.attributes && containerObject.attributes.partialVisibilityGutter ? parseInt(containerObject.attributes.partialVisibilityGutter) : 20)
		},
		desktop: {
			breakpoint: { max: 3000, min: 1024 },
			items: containerObject && containerObject.attributes && containerObject.attributes.desktop ? parseInt(containerObject.attributes.desktop) : 4,
			partialVisibilityGutter: (containerObject && containerObject.results && containerObject.results.length) == (containerObject && containerObject.attributes && containerObject.attributes.desktop ? parseInt(containerObject.attributes.desktop) : 4) ? 0 :
				(containerObject && containerObject.attributes && containerObject.attributes.partialVisibilityGutter ? parseInt(containerObject.attributes.partialVisibilityGutter) : 20)
		},
		tablet: {
			breakpoint: { max: 1024, min: 464 },
			items: containerObject && containerObject.attributes && containerObject.attributes.tablet ? parseInt(containerObject.attributes.tablet) : 1,
		},
		mobile: {
			breakpoint: { max: 464, min: 0 },
			items: containerObject && containerObject.attributes && containerObject.attributes.mobile ? parseInt(containerObject.attributes.mobile) : 1,
		},
	};

	const handlePrevious = () => {
		setCurrentSlide(currentSlide - 1);
		carouselRef.current.previous();
	};

	const handleNext = () => {
		setCurrentSlide(currentSlide + 1);
		carouselRef.current.next();
	};

	function replaceImage(event) {
		event.target.src = DEFAULT_IMAGE_140;
	}

	useEffect(() => {
		setScreenWidth(screen.width)
	}, [])

	const productDetailsCallBack = (productDetails) => {
		setproductDetailsObj(productDetails)
	}

	const productCountCallBack = (count) => {
		setProductCount(count)
	}

	useEffect(() => {
		if (screenWidthRef.current < 1024) {
			//console.log('featurenextButton ---- ')
			if (document.querySelector("#featurenextButton") != null) {
				const sliderButton = document.querySelector("#featurenextButton");
				//console.log('sliderButton ---- ', sliderButton)
				sliderButton.click();
			}
		}
	}, [screenWidthRef.current])

	const handleAddToCartAction = (addToCart) => {
		setIsAddToCartAction(addToCart)
	}

	return (
		<>
			<div className={`${(containerObject && containerObject.results && containerObject.results.length > 4 && screenWidthRef.current > 1024) ? "featured-slider-top" : ""} col-md-12`}>
				<div className={`${(containerObject && containerObject.results && containerObject.results.length <= 4 && screenWidthRef.current > 1024) ? "d-lg-block d-md-block" : screenWidthRef.current < 1024 ? "d-lg-block d-md-block" : "d-none"} d-flex featuredProductSlider`}>
					{props.hideTitle ? "" : <div className={`${titleCss ? titleCss : "featuredProductTitileCss col-md-10 col-12"} `}>
						<h2 className=''>{title}</h2>
					</div>}
					{containerObject && containerObject.results && containerObject.results.length > responsive.desktop.items == true ?
						<div className='col-3 d-none'>
							<button className={`cb-previous-button mx-4 ${currentSlide === 0 ? 'disabled' : 'd-none'}`} onClick={() => handlePrevious()} disabled={currentSlide === 0}>
								<svg className='cb-caret-previous' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 256 512"><path d="M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z" /></svg>
							</button>
							<button id="featurenextButton" className={`cb-next-button ${currentSlide >= containerObject.results.length - (responsive.desktop.items) ? 'disabled' : 'd-none'}`} onClick={() => handleNext()} disabled={currentSlide >= containerObject.results.length - (responsive.desktop.items)}>
								<svg className='cb-caret-next' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 256 512"><path d="M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z" /></svg>
							</button>
						</div> : ""}
				</div>
			</div>

			{screenWidthRef.current > 1024 ?
				<Carousel
					ref={carouselRef}
					swipeable={true}
					draggable={true}
					showDots={false}
					responsive={responsive}
					ssr
					infinite={false}
					customLeftArrow={<button className={`${containerObject && containerObject.results && containerObject.results.length <= 4 ? "d-none" : ""} customLeftArrow`}><h2 className=' ymalTextPosition'>{title}</h2> <button className={`cb-previous-button mx-4 ymalPreviousButtonPosition`} >
						<svg className='cb-caret-previous' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 256 512"><path d="M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z" /></svg>
					</button></button>}
					customRightArrow={<button className={`${containerObject && containerObject.results && containerObject.results.length <= 4 ? "d-none" : ""} cb-next-button ymalnextButtonPosition `} >
						<svg className='cb-caret-next' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 256 512"><path d="M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z" /></svg>
					</button>}
					autoPlay={false}
					arrows={true}
					renderArrowsWhenDisabled={true}
					partialVisible={true}
					autoPlaySpeed={0}
					keyBoardControl={true}
					removeArrowOnDeviceType={['']}
					deviceType="desktop"
					className={`${containerObject && containerObject.results && containerObject.results.length <= 4 ? "" : "pre-next-carousal"} custom-carousel`}
					itemClass="custom-item-class justify-content-center d-flex"
				>
					{containerObject && containerObject.results && containerObject.results.map((featuredItem, index) => {

						return (
							<>
								<div className={`fetaured-justifiy-content-center horizontal-carousal`}>
									{containerObject.attributes && containerObject.attributes.rederAsPLP === "true" ?
										<div className={`${containerObject.attributes && containerObject.attributes.rederAsPLP === "true" ? "horizontal-from-featured-product" : ""}`}>
											<ProductTile domainName={containerObject.domainName ? containerObject.domainName : ""} pageType={containerObject.productViewType && containerObject.productViewType === "p" ? "product" : containerObject.productViewType && containerObject.productViewType === "c" ? "resources" : ""} value={featuredItem ? featuredItem : ""} indexValue={index} currentPageView={"gridView"} productDetailsCallBack={productDetailsCallBack} productCountCallBack={productCountCallBack} gridViewCol={"col-12"} />
										</div>
										:
										<div class="c-feature-product qv-model">
											<Link to={featuredItem["productUrl"]} class="c-product-link">
												{containerObject.attribute && containerObject.attributes.imageFetchPriortityAttr && containerObject.attributes.imageFetchPriortityAttr == "lazy" ?
													<img alt={featuredItem["product.productName"] ? featuredItem["product.productName"] : ""} onError={replaceImage} src={featuredItem["product.smallImageUrl"] ? featuredItem["product.smallImageUrl"] : ""} class="c-product-img" loading="lazy" decoding='async'/>
													:
													<img alt={featuredItem["product.productName"] ? featuredItem["product.productName"] : ""} onError={replaceImage} src={featuredItem["product.smallImageUrl"] ? featuredItem["product.smallImageUrl"] : ""} class="c-product-img" fetchPriority={containerObject.attributes && containerObject.attributes.imageFetchPriortityAttr == "low" ? "low" : "high"} decoding='async'/>}

												<h3 class="cb-product-title" dangerouslySetInnerHTML={{ __html: featuredItem["product.productName"] ? featuredItem["product.productName"] : "" }}>
												</h3>
											</Link>
											<div class="c-product-rating">
												{featuredItem.reviewURLAverage ?
													containerObject.attribute && containerObject.attributes.imageFetchPriortityAttr && containerObject.attributes.imageFetchPriortityAttr == "lazy" ?
														<img src={`/images/stars/50/rating-${featuredItem.reviewURLAverage ? featuredItem.reviewURLAverage : ""}_50.png`} alt={featuredItem.reviewURLAverage ? featuredItem.reviewURLAverage : ""} loading="lazy" />
														:
														<img src={`/images/stars/50/rating-${featuredItem.reviewURLAverage ? featuredItem.reviewURLAverage : ""}_50.png`} alt={featuredItem.reviewURLAverage ? featuredItem.reviewURLAverage : ""} fetchPriority={containerObject.attributes && containerObject.attributes.imageFetchPriortityAttr == "low" ? "low" : "high"} />
													: ""}
											</div>
											{featuredItem["product.mediaType"] ?
												<p class="c-product-info">
													<i title={featuredItem["product.mediaType"]} className={`${featuredItem["product.mediaType"] == "Document" ? "bi bi-filetype-pdf" : featuredItem["product.mediaType"] == "Interactive" ? "bi bi-link-45deg" : ""}`}></i>
													{featuredItem["product.mediaType"]}
												</p> :
												<>
													<div className="cb-horizontal-featured-product">
														{/* {featuredItem["product.familyProduct.count"] ? <p class="c-product-total">{featuredItem["product.familyProduct.count"] ? featuredItem["product.familyProduct.count"] : ""}&nbsp; products</p> : featuredItem["product.productId"] ? <p class="c-product-total">Item #{featuredItem["product.productId"] ? featuredItem["product.productId"] : ""}</p> : ""} */}

														<p className='silder-price m-0'>
															{profileDetails && profileDetails.hidePrice === "true" && profileDetails.call_for_pricing ? <p class="c-product-price cb-call-for-price">{profileDetails.call_for_pricing}</p> :
																profileDetails && profileDetails.userType == "2" ?
																	<>
																		{featuredItem.retailPrice != null && featuredItem.retailPrice != undefined ?
																			featuredItem.contractPrice ?
																				<span class="contract-price-value">{featuredItem.contractPrice ? featuredItem.contractPrice : ""}</span> :
																				<div class="prod-contract-disc">
																				<div class="prod-contract-price">
																					<span class="contract-price-value">{featuredItem.itemPrice ? featuredItem.itemPrice : ""}</span>
																				</div>
																			</div>
																			: featuredItem.contractPrice && featuredItem.itemPrice ? <div className="d-flex cb-list-price-red"> <p class="list-price-value mx-1">{featuredItem.itemPrice ? featuredItem.itemPrice : ""}</p> <span class="c-product-price-value">{featuredItem.contractPrice ? featuredItem.contractPrice : ""}</span></div> :
																				<div class="prod-contract-disc">
																					<div class="prod-contract-price">
																						<span class="contract-price-value">{featuredItem.itemPrice ? featuredItem.itemPrice : ""}</span>
																					</div>
																				</div>}

																		{featuredItem.retailPrice && featuredItem.retailPrice != "$0.00" ? <div class="prod-retail-price">
																			Retail<span class="list-price-value">{featuredItem.retailPrice}</span>
																		</div> : ""}

																	</> : <>{featuredItem.oldPrice && featuredItem.itemPrice ? <div className="d-flex cb-list-price-red">
																		<p class={`list-price-value mx-1`}>{featuredItem.oldPrice ? featuredItem.oldPrice : ""}</p><span class="c-product-price-value">{featuredItem.itemPrice ? featuredItem.itemPrice : ""}</span></div>
																		: <p class="c-product-price">{featuredItem.qtyRange ? featuredItem.qtyRange : featuredItem.itemPrice ? featuredItem.itemPrice : ""}</p>} </>}
														</p>

														{featuredItem["product.familyProduct.count"] ? <p class="c-product-total">{featuredItem["product.familyProduct.count"] ? <>{featuredItem["product.familyProduct.count"]}&nbsp; Products </> : ""}</p> :
															<>
																{profileDetails && profileDetails.hidePrice === "true" && profileDetails.call_for_pricing ? <p class="c-product-price cb-call-for-price">{profileDetails.call_for_pricing}</p> :
																	profileDetails && profileDetails.userType == "2" ?
																		<>
																			{featuredItem.retailPrice != null && featuredItem.retailPrice != undefined ?
																				featuredItem.contractPrice ?
																					<span class="contract-price-value">{featuredItem.contractPrice ? featuredItem.contractPrice : ""}</span> :
																					<div class="prod-contract-disc">
																					<div class="prod-contract-price">
																						<span class="contract-price-value">{featuredItem.itemPrice ? featuredItem.itemPrice : ""}</span>
																					</div>
																				</div>
																				: featuredItem.contractPrice && featuredItem.itemPrice ? <div className="d-flex cb-list-price-red"> <p class="list-price-value mx-1">{featuredItem.itemPrice ? featuredItem.itemPrice : ""}</p> <span class="c-product-price-value">{featuredItem.contractPrice ? featuredItem.contractPrice : ""}</span></div> :
																					<div class="prod-contract-disc">
																						<div class="prod-contract-price">
																							<span class="contract-price-value">{featuredItem.itemPrice ? featuredItem.itemPrice : ""}</span>
																						</div>
																					</div>}

																			{featuredItem.retailPrice && featuredItem.retailPrice != "$0.00" ?
																				<div class="prod-retail-price">
																					Retail<span class="list-price-value">{featuredItem.retailPrice ? featuredItem.retailPrice : ""}</span>
																				</div> : ""}

																		</>
																		: <>{featuredItem.oldPrice && featuredItem.itemPrice ? <div className="d-flex cb-list-price-red">
																			<p class={`list-price-value mx-1`}>{featuredItem.oldPrice ? featuredItem.oldPrice : ""}</p><span class="c-product-price-value">{featuredItem.itemPrice ? featuredItem.itemPrice : ""}</span></div>
																			: <p class="c-product-price">{featuredItem.qtyRange ? featuredItem.qtyRange : featuredItem.itemPrice ? featuredItem.itemPrice : ""}</p>} </>}
															</>}
													</div>
													{profileDetails && profileDetails.call_for_pricing ? "" : <div className="">
														{featuredItem && featuredItem.qtyDiscountAvailable && featuredItem.qtyDiscountAvailable == true ? <p className="my-0 cb-itemDiscount">Qty Discount Available</p> : ""}
													</div>}

													{quickView === "false" ?
														<form onSubmit={handleQuickViewProductPage} className="" id={`quickViewModalForm${index}`}>
															<input type="hidden" name="productIdss" value={featuredItem["product.productId"]} id={`productObj${index}`} />
															<input type="hidden" name="productCount" value={featuredItem["product.familyProduct.count"] ? featuredItem["product.familyProduct.count"] : ""} id={`productObj${index}`} />
															<button type="submit" className="btn quick-btn modal-link" >Quick View</button>
														</form> : ""}
												</>}
										</div>}
								</div>
							</>
						)
					})}
					{/* <Product containerObject={containerObject ? containerObject : ""}/> */}
				</Carousel>
				:
				<Carousel
					ref={carouselRef}
					swipeable={true}
					draggable={true}
					showDots={false}
					responsive={responsive}
					ssr
					infinite={false}
					autoPlay={false}
					autoPlaySpeed={0}
					keyBoardControl={true}
					transitionDuration={200}
					removeArrowOnDeviceType={['desktop']}
					deviceType="desktop"
					className='custom-carousel'
					itemClass="custom-item-class"
					centerMode={true}
				>

					{containerObject && containerObject.results && containerObject.results.map((featuredItem, index) => {

						return (
							<>
								<div className={`fetaured-justifiy-content-center horizontal-carousal`}>
									{containerObject.attributes && containerObject.attributes.rederAsPLP === "true" ?
										<div className={`${containerObject.attributes && containerObject.attributes.rederAsPLP === "true" ? "horizontal-from-featured-product" : ""}`}>
											<ProductTile domainName={containerObject.domainName ? containerObject.domainName : ""} pageType={containerObject.productViewType && containerObject.productViewType === "p" ? "product" : containerObject.productViewType && containerObject.productViewType === "c" ? "resources" : ""} value={featuredItem ? featuredItem : ""} indexValue={index} currentPageView={"gridView"} productDetailsCallBack={productDetailsCallBack} productCountCallBack={productCountCallBack} gridViewCol={"col-12"} />
										</div>
										:
										<div class="c-feature-product qv-model">
											<Link to={featuredItem["productUrl"]} class="c-product-link">
												<img alt={featuredItem["product.productName"] ? featuredItem["product.productName"] : ""} onError={replaceImage} src={featuredItem["product.smallImageUrl"] ? featuredItem["product.smallImageUrl"] : ""} class="c-product-img" fetchPriority={containerObject.attributes && containerObject.attributes.imageFetchPriortityAttr == "low" ? "low" : "high"} />
												<h3 class="cb-product-title" dangerouslySetInnerHTML={{ __html: featuredItem["product.productName"] ? featuredItem["product.productName"] : "" }}>
												</h3>
											</Link>

											{featuredItem["product.mediaType"] ?
												<p class="c-product-info">
													<i title={featuredItem["product.mediaType"]} className={`${featuredItem["product.mediaType"] == "Document" ? "bi bi-filetype-pdf" : featuredItem["product.mediaType"] == "Interactive" ? "bi bi-link-45deg" : ""}`}></i>
													{featuredItem["product.mediaType"]}
												</p> :
												<>
													<div className="cb-horizontal-featured-product">
														<p className='silder-price'>
															{profileDetails && profileDetails.hidePrice === "true" && profileDetails.call_for_pricing ? <p class="c-product-price cb-call-for-price">{profileDetails.call_for_pricing}</p> :
																profileDetails && profileDetails.userType == "2" ?
																	<>
																		{featuredItem.retailPrice != null && featuredItem.retailPrice != undefined ?
																			featuredItem.contractPrice ?
																				<span class="contract-price-value">{featuredItem.contractPrice ? featuredItem.contractPrice : ""}</span> : 
																				<div class="prod-contract-disc">
																					<div class="prod-contract-price">
																						<span class="contract-price-value">{featuredItem.itemPrice ? featuredItem.itemPrice : ""}</span>
																					</div>
																				</div>
																			: featuredItem.contractPrice && featuredItem.itemPrice ? <div className="d-flex cb-list-price-red"> <p class="list-price-value mx-1">{featuredItem.itemPrice ? featuredItem.itemPrice : ""}</p> <span class="c-product-price-value">{featuredItem.contractPrice ? featuredItem.contractPrice : ""}</span></div> :
																				<div class="prod-contract-disc">
																					<div class="prod-contract-price">
																						<span class="contract-price-value">{featuredItem.itemPrice ? featuredItem.itemPrice : ""}</span>
																					</div>
																				</div>}

																		{featuredItem.retailPrice && featuredItem.retailPrice != "$0.00" ?
																			<div class="prod-retail-price">
																				Retail<span class="list-price-value">{featuredItem.retailPrice ? featuredItem.retailPrice : ""}</span>
																			</div> : ""}
																	</> : <>{featuredItem.oldPrice && featuredItem.itemPrice ? <div className="d-flex cb-list-price-red">
																		<p class={`list-price-value mx-1`}>{featuredItem.oldPrice ? featuredItem.oldPrice : ""}</p><span class="c-product-price-value">{featuredItem.itemPrice ? featuredItem.itemPrice : ""}</span></div>
																		: <p class="c-product-price">{featuredItem.qtyRange ? featuredItem.qtyRange : featuredItem.itemPrice ? featuredItem.itemPrice : ""}</p>} </>}
														</p>

														{featuredItem["product.familyProduct.count"] ? <p class="c-product-total">{featuredItem["product.familyProduct.count"] ? <>{featuredItem["product.familyProduct.count"]}&nbsp; Products </> : ""}</p> :
															<>
																{profileDetails && profileDetails.hidePrice === "true" && profileDetails.call_for_pricing ? <p class="c-product-price">{profileDetails.call_for_pricing}</p> :
																	profileDetails && profileDetails.userType == "2" ?
																		<>
																			{featuredItem.retailPrice != null && featuredItem.retailPrice != undefined ?
																				featuredItem.contractPrice ?
																					<span class="contract-price-value">{featuredItem.contractPrice ? featuredItem.contractPrice : ""}</span> : 
																					<div class="prod-contract-disc">
																					<div class="prod-contract-price">
																						<span class="contract-price-value">{featuredItem.itemPrice ? featuredItem.itemPrice : ""}</span>
																					</div>
																				</div>
																				: featuredItem.contractPrice && featuredItem.itemPrice ? <div className="d-flex cb-list-price-red"> <p class="list-price-value mx-1">{featuredItem.itemPrice ? featuredItem.itemPrice : ""}</p> <span class="c-product-price-value">{featuredItem.contractPrice ? featuredItem.contractPrice : ""}</span></div> :
																					<div class="prod-contract-disc">
																						<div class="prod-contract-price">
																							<span class="contract-price-value">{featuredItem.itemPrice ? featuredItem.itemPrice : ""}</span>
																						</div>
																					</div>}

																			{featuredItem.retailPrice && featuredItem.retailPrice != "$0.00" ?
																				<div class="prod-retail-price">
																					Retail<span class="list-price-value">{featuredItem.retailPrice ? featuredItem.retailPrice : ""}</span>
																				</div> : ""}
																		</> : <>{featuredItem.oldPrice && featuredItem.itemPrice ? <div className="d-flex cb-list-price-red">
																			<p class={`list-price-value mx-1`}>{featuredItem.oldPrice ? featuredItem.oldPrice : ""}</p><span class="c-product-price-value">{featuredItem.itemPrice ? featuredItem.itemPrice : ""}</span></div>
																			: <p class="c-product-price">{featuredItem.qtyRange ? featuredItem.qtyRange : featuredItem.itemPrice ? featuredItem.itemPrice : ""}</p>} </>}
															</>}
													</div>
													<div class="c-product-rating">
														{featuredItem.reviewURLAverage ? <img src={`/images/stars/50/rating-${featuredItem.reviewURLAverage ? featuredItem.reviewURLAverage : ""}_50.png`} alt={featuredItem.reviewURLAverage ? featuredItem.reviewURLAverage : ""} fetchPriority={containerObject.attributes && containerObject.attributes.imageFetchPriortityAttr == "low" ? "low" : "high"} /> : ""}
													</div>
													{profileDetails && profileDetails.call_for_pricing ? "" : <div className="">
														{featuredItem && featuredItem.qtyDiscountAvailable && featuredItem.qtyDiscountAvailable == true ? <p className="my-0 cb-itemDiscount">Qty Discount Available</p> : ""}
													</div>}
													{quickView === "false" ?
														<form onSubmit={handleQuickViewProductPage} className="" id={`quickViewModalForm${index}`}>
															<input type="hidden" name="productIdss" value={featuredItem["product.productId"]} id={`productObj${index}`} />
															<input type="hidden" name="productCount" value={featuredItem["product.familyProduct.count"] ? featuredItem["product.familyProduct.count"] : ""} id={`productObj${index}`} />
															<button type="submit" className="btn quick-btn modal-link" >Quick View</button>
														</form> : ""}
												</>}
										</div>
									}
								</div>
							</>
						)
					})}
					{/* <Product containerObject={containerObject ? containerObject : ""}/> */}
				</Carousel>}
			{productDetailsObj ? <ProductQuickViewModal handleAddToCartAction={handleAddToCartAction} productObj={productDetailsObj} solrValue={productCount} cartProductDetailsCallBack={cartProductDetailsCallBack} /> : ""}
		</>

	)
}

export default FeaturedProductSlider
